<template>
  <div class="forget-password-page">
    <div class="header">
      <div style="margin-left: 20px;">
        <img src="../assets/logo.png" alt="" style="width: 109px;">
      </div>
      <div style="display: flex; margin-right: 30px; align-items: center;">
        <div class="web" @click="web('http://www.kaitaiming.com')"><a-icon type="ie"></a-icon>官网</div>
        <div class="web" @click="web('https://www.ktmbj.com')" style="margin-left: 20px; width: 100px;"><a-icon type="chrome"></a-icon>海外官网</div>
      </div>
    </div>

    <div class="container">
      <forget-password></forget-password>
    </div>
  </div>
</template>

<script>
import ForgetPassword from '../components/ForgetPassword.vue';

export default {
  name: 'ForgetPasswordPage',
  components: {
    ForgetPassword,
  },
  methods: {
    web(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
.forget-password-page {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.header {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 5px 10px rgb(181 181 181);
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;
}

.container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 80px;
}

.web {
  background-color: #10496B;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 5px;
  width: 80px;
  text-align: center;
  cursor: pointer;
}
</style>
